import { render, staticRenderFns } from "./BootVersionList.vue?vue&type=template&id=3a1a6dec&scoped=true"
import script from "./BootVersionList.vue?vue&type=script&lang=js"
export * from "./BootVersionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1a6dec",
  null
  
)

export default component.exports